import {
  ChangePinPayload,
  ConfirmPinResetPayload,
  CreatePinPayload,
} from '@/types/user'
import { identityClient } from './axiosClient'

const ROOT_API = '/api/auth/pin'

const pinApi = {
  createPin(payload: CreatePinPayload) {
    const url = ROOT_API
    return identityClient.post(url, payload)
  },

  changePin(payload: ChangePinPayload) {
    const url = ROOT_API
    return identityClient.put(url, payload)
  },

  requestPinReset() {
    const url = `${ROOT_API}/reset/request`
    return identityClient.post(url)
  },

  confirmPinReset(payload: ConfirmPinResetPayload) {
    const url = `${ROOT_API}/reset/confirm`
    return identityClient.post(url, payload)
  },
}

export default pinApi
